import { makeStyles } from '@material-ui/styles';
import { ITheme } from 'typings/theme';

export default makeStyles((theme: ITheme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  editor: {
    backgroundColor: '#FFF',
    minWidth: 440,
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '10',
  },
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
  },
  btnSave: {
    backgroundColor: 'gray',
    color: 'white',
  },
  labelCenter: {
    fontSize: 10,
    marginTop: 15,
    textAlign: 'center',
  },
  wrapper: {
    width: '100%',
    padding: 15,
  },
}));
